export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setConfig(state, config) {
    state.config = config;
  }
};
